import { STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE } from "../actions-type";

const initalState = {
  studentPerformanceCommonModalData: {},
  studentPerformanceCommonOpenModal: false,
  studentPerformanceCommonModalLoading: false,
};

export const studentPerformanceCommonModalReducer = (state = initalState, action) => {
  switch (action.type) {
    case STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE.GET_STUDENT_PERFORMANCE_COMMON_MODAL:
      return {
        ...state,
        studentPerformanceCommonModalData: action.payload.data,
        studentPerformanceCommonOpenModal: action.payload.openModal,
      };
    case STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_COMMON_OPEN_MODAL:
      return {
        ...state,
        studentPerformanceCommonOpenModal: action.payload,
      };
    case STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_COMMON_MODAL_LOADING:
      return {
        ...state,
        studentPerformanceCommonModalLoading: action.payload,
      };
    default:
      return state;
  }
};
